import { listPhysicians } from './index';

import { physiciansRouteStore } from '../domain/store';

export default (number) => {
  physiciansRouteStore.setValue('currentPage', number);
  return listPhysicians();
};
